import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import StudentEngagementTable from './StudentEngagementTable';
import { StudentEngagementListService } from '../../services/CustomerSuccessKpiListService';
import { get } from 'lodash';

class StudentEngagementDetailTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentEngagementListService.load();
  }

  render() {
    return (
      <StudentEngagementTable
        loading={
          StudentEngagementListService.fetchCurrent.fetching || StudentEngagementListService.fetchPrevious.fetching
        }
        values={toJS(StudentEngagementListService.getCompaniesByType(this.props.type, this.props.typeId))}
        feedbackColorRender={StudentEngagementListService.getFeedbackColor}
        onSelect={(row) =>
          browserHistory.push(
            `/kpis/customer-success/${this.props.type}/${get(this.props, 'typeId', 'NA')}/company/${row.id}/details`
          )
        }
        formatter={StudentEngagementListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentEngagementDetailTableContainer);
